import { Reveal } from "@/components/Reveal";
import { ServiceIcon } from "@/components/ServiceIcon";
import { useCollection } from "@/hooks/useCollection";
import { fileUrl } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

const PageHeader = ({ eyebrow, title, subtitle }) => (
  <section className="relative grid-bg border-b border-amber-500/10">
    <div className="absolute inset-0 radial-glow" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-20">
      <Reveal>
        <div className="text-xs tracking-[0.3em] text-gold uppercase mb-3">{eyebrow}</div>
        <h1 className="font-syne font-black text-4xl sm:text-5xl text-white">{title}</h1>
        {subtitle && <p className="text-white/60 mt-4 max-w-2xl text-lg">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export default function Services() {
  const { items: services } = useCollection("services");
  const { items: products } = useCollection("products");
  return (
    <div>
      <PageHeader eyebrow="Layanan Kami" title="Layanan & Produk Unggulan" subtitle="Solusi teknologi menyeluruh yang dirancang untuk keamanan, efisiensi, dan pertumbuhan bisnis Anda." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24 space-y-16">
        {services.map((s, i) => (
          <Reveal key={s.id}>
            <div className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
              <div className="rounded-3xl overflow-hidden gold-border [direction:ltr]">
                <img src={fileUrl(s.image)} alt={s.title} className="w-full h-72 object-cover live-img" />
              </div>
              <div className="[direction:ltr]">
                <div className="w-12 h-12 rounded-xl btn-gold flex items-center justify-center mb-4"><ServiceIcon name={s.icon} className="w-6 h-6" /></div>
                <h2 className="font-syne font-bold text-2xl sm:text-3xl text-white">{s.title}</h2>
                <p className="text-white/70 mt-4 leading-relaxed">{s.description}</p>
                <ul className="mt-5 space-y-2">
                  {["Konsultasi & analisis kebutuhan","Implementasi profesional","Dukungan & maintenance berkala"].map((f) => (
                    <li key={f} className="flex items-center gap-2 text-white/70 text-sm"><CheckCircle2 className="w-4 h-4 text-gold" /> {f}</li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
      {products.length > 0 && (
        <section className="bg-[#0F1117] border-t border-amber-500/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24">
            <Reveal><h2 className="font-syne font-bold text-2xl sm:text-3xl text-white mb-10">Katalog <span className="gold-gradient-text">Produk</span></h2></Reveal>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {products.map((p, i) => (
                <Reveal key={p.id} delay={i * 0.06}>
                  <div className="bg-ll-card rounded-2xl overflow-hidden card-hover gold-border h-full flex flex-col">
                    {p.image && <div className="h-44 overflow-hidden relative"><img src={fileUrl(p.image)} alt={p.name} className="w-full h-full object-cover" /><span className="absolute top-3 left-3 px-3 py-1 rounded-full text-[10px] btn-gold font-bold">{p.category}</span></div>}
                    <div className="p-6 flex-1 flex flex-col">
                      <h3 className="font-syne font-semibold text-lg text-white">{p.name}</h3>
                      <p className="text-sm text-white/60 mt-2 flex-1">{p.description}</p>
                      <div className="mt-4 text-gold font-bold font-mono-ll">{p.price}</div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export { PageHeader };
